/**
 * Template: Product
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */
import {debounce, on} from '~/helpers/utils';
import {disableBodyScroll, enableBodyScroll} from 'body-scroll-lock';
import Accordion from '~/components/accordion';
import ProductForm from '~/components/product-form';
import ProductGallery from '~/components/product-gallery';
import FeatureCarousel from '~/components/feature-carousel';
import NavigatorShare from '~/components/navigator-share';
import Toggle from '~/components/toggle';
import sizeChart from '../components/size-chart-modal';

import SimpleBar from 'simplebar';
import 'simplebar/dist/simplebar.css';


import '../sections/image-video-hero';

import '../../styles/templates/product.scss';

import '../../styles/components/product-form.scss';
import '../../styles/components/product-gallery.scss';
import '../../styles/components/product-spare-parts.scss';

import '../../styles/components/product-engraving.scss';
import '../../styles/components/breadcrumb.scss';

/**
 * DOM selectors.
 */
const selectors = {
  asideScrollable: '[js-product="asideScrollable"]',
  swatchContainer: '[js-product-form="swatch-container"]',
  descShow: '[js-size-chart="descShow"]',
};

/**
 * Create a new drawer instance.
 */
const Drawer = Toggle({
  toggleSelector: 'moreInformation',
});

document.addEventListener('DOMContentLoaded', () => {

  /**
   * DOM node selectors.
   */
  const nodeSelectors = {
    asideScrollable: document.querySelector(selectors.asideScrollable),
    swatchContainer: document.querySelector(selectors.swatchContainer),
    descShow: document.querySelector(selectors.descShow),
  };

  Drawer.init();

  Frame.EventBus.emit('Datalayer:push', window.productDataLayer);

  FeatureCarousel().init();

  ProductGallery().init();

  Accordion('#productAccordion', {
    singleOpen: false,
  }).init();

  const activeAsideScrollable = new SimpleBar(nodeSelectors.asideScrollable, {
    autoHide: false,
  });

  if (typeof(nodeSelectors.descShow) != 'undefined' && nodeSelectors.descShow != null) {
    sizeChart().init();
  }

  Frame.EventBus.listen('Toggle:moreInformation:open', () => {
    disableBodyScroll(document.body);

    window.dataLayer.push({
      event: 'GAevent',
      eventID: '14',
      eventCategory: 'product',
      eventAction: 'button',
      eventLabel: 'more_info',
    });
  });

  Frame.EventBus.listen('Toggle:moreInformation:close', () => {
    enableBodyScroll(document.body);
  });

  on('resize', debounce(activeAsideScrollable.recalculate(), 250));

  NavigatorShare().init();

  /**
   * Check if product form has swatches.
   */
  function hasSwatches() {
    return Boolean(nodeSelectors.swatchContainer);
  }

  ProductForm({
    container: 'container',
    enableSwatches: hasSwatches(),
  }).init();
});
